import React from 'react';
import {
  faPencilAlt,
  faCopy,
  faArchive,
} from '@fortawesome/free-solid-svg-icons';
import DashItemMenu from 'components/DashItemMenu';

const EventListItemMenu = ({ event, onEdit, onArchive, onDuplicate }) => {
  const teamId = event.team._id ? event.team._id : event.team;

  const items = [
    {
      onClick: onEdit,
      icon: faPencilAlt,
      title: 'Edit event settings',
      displayForAdmin: true,
      includeTeamAdmin: true,
      eventId: event._id,
      teamId,
    },
    {
      onClick: onDuplicate,
      icon: faCopy,
      title: 'Duplicate',
    },
    {
      onClick: onArchive,
      icon: faArchive,
      title: 'Archive',
    },
  ];

  return <DashItemMenu items={items} />;
};

export default EventListItemMenu;
